import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/app/(navbar)/faqs/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IdeaStarterBanner"] */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/components/idea-starter-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MembershipBanner"] */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/components/membership-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpotlightQuestionsBanner"] */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/components/spotlight-questions-banner.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src999447862/src/ihs-web-app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src999447862/src/ihs-web-app/node_modules/next/dist/client/image-component.js");
